import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    building: [
//                 {
//                     whereabouts: '所在1',
//                     houseNumber1: '家屋番号1',
//                     type: '種類1',
//                     construction: '構造1',
//                     floorspace: [[null, 1, 2],[null,'床面積1-1', '床面積1-2']],
//                     enquity: '持分1',
//                     propertyTaxValuation: '1000000',
//                     targetPerson: 'テスト相続人1',
//                     inheritanceBequest: '相続',
//                 },
//                 {
//                     whereabouts: '所在2',
//                     houseNumber1: '家屋番号2',
//                     type: '種類2',
//                     construction: '構造2',
//                     floorspace: [[null, 1],[null,'床面積2-1']],
//                     enquity: '持分2',
//                     propertyTaxValuation: '1000000',
//                     targetPerson: 'テスト相続人2',
//                     inheritanceBequest: '相続',
//                 },
//                 {
//                     whereabouts: '所在3',
//                     houseNumber1: '家屋番号3',
//                     type: '種類3',
//                     construction: '構造3',
//                     floorspace: [[null, 1, 2, 3],[null,'床面積3-1', '床面積3-2', '床面積3-3']],
//                     enquity: '持分3',
//                     propertyTaxValuation: '1000000',
//                     targetPerson: 'テスト相続人3',
//                     inheritanceBequest: '相続',
//                 }
    ]
};

const slice = createSlice({
    name: 'building',
    initialState,
    reducers: {
        setBuilding: (state, action) => {
            return Object.assign({}, state, { building: state.building.concat(action.payload) })
        },
        clearBuilding: (state, action) => {
            const newArray = Array.from(new Set([...state.building]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { building: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setBuilding,
    clearBuilding,
} = slice.actions;
